export default [
  {
    path: '/etreasury/:key?',
    name: 'etreasury',
    component: () => import('@/views/etreasury/EtreasuryProcessIndex.vue'),
    meta: {},
  },
  {
    path: '/etreasuryconnect',
    name: 'etreasury-connection',
    component: () => import('@/views/etreasury/process/DVCProcessConnection.vue'),
    meta: {},
  }
];
